/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Board_TitleInputs */

const en_directory_launch_board_title = /** @type {(inputs: Directory_Launch_Board_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly Launch Board`)
};

const zh_directory_launch_board_title = /** @type {(inputs: Directory_Launch_Board_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月度工具榜`)
};

/**
* | output |
* | --- |
* | "Monthly Launch Board" |
*
* @param {Directory_Launch_Board_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_board_title = /** @type {((inputs?: Directory_Launch_Board_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Board_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_board_title(inputs)
	return zh_directory_launch_board_title(inputs)
});
export { directory_launch_board_title as "directory.launch.board_title" }